export const amountFormatted = (amount, currency = 'USD') => {
  if (!amount || amount === '0') return '';
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};
